<div>
  <div class="dropdown">
    <div class="dropdown-header" fxLayout="row" fxLayoutAlign="space-between center">
      <div>
        <div class="dropdown-heading">{{'GENERAL.RECENT_PAGES' | translate}}</div>
      </div>
    </div>
    @if(recentPages?.length > 0) {
    <div @stagger class="dropdown-content">

      @for (recentPage of recentPages; track recentPage.url; let index = $index; let last = $last) {

      <a [ngClass]="last ? 'last-recent-page' : ''" (click)="goToPage(recentPage)" class="recent-page" fxLayout="row"
        fxLayoutAlign="start center" matRipple>
        <mat-icon mat-icon class="item-icon mr-2" style="width: 42px; height: 42px;">
          <net-iconify-icon [icon]="recentPage.icon" fxFlex="none" size="24" color="#5c78fd"></net-iconify-icon>
        </mat-icon>
        <span class="recent-page-label" fxFlex="auto">{{ getTranslation(recentPage.label) }}</span>
      </a>

      }

    </div>
    }

    @if (recentPages?.length === 0){
    <div @stagger class="dropdown-content">
      <a class="recent-page" style="margin-bottom: 10px;" fxLayout="row" fxLayoutAlign="center center" matRipple>
        <span style="font-size: 14px;">{{'GENERAL.THERE_ARE_NO_RECENT_PAGES' | translate}}</span>
      </a>
    </div>
    }

    @if (loading) {
    <div>
      <mat-progress-spinner mode="indeterminate" diameter="42" class="mx-auto my-6">
      </mat-progress-spinner>
    </div>
    }

  </div>
</div>